import Header from "../components/Header";
import Footer from "../components/Footer";

const Menu = () => {
  return (
    <div>
      <Header />
      <h1 className="page-heading">Menu</h1>
      <p className="page-paragraph">...</p>
      <Footer />
    </div>
  );
};

export default Menu;
